import { Component } from '@angular/core';
import {AlertController, ModalController, NavController, NavParams, PopoverController} from 'ionic-angular';

import { ConferenceData } from '../../../../providers/conference-data';
import {MissionsData} from "../../../../providers/missions-data";
import {MissionsFilterPage} from "../../missions-filter/missions-filter";
import {MissionsPostulatePage} from "../../missions-postulate/missions-postulate";
import {UserData} from "../../../../providers/user-data";

import {SupportPage} from "../../../support/support";
import {MissionsCandidatePage} from "../mission-candidate-list/missions-candidate";
import {MissionsSignPage} from "../../missions-sign/missions-sign"
import {DocumentSelectForm} from "../../../utils/document-select/document-select";
import {VideoRecorderForm} from "../../../utils/video-recorder/video-recorder";
import {VideoWizardForm} from "../../../utils/video-wizard/video-wizard";
import {LocationViewer} from "../../../utils/location-viewer/location-viewer";
import {UiData} from "../../../../providers/ui-data";
import {MissionCandidateDetailPopover} from "./popover";

@Component({
    selector: 'page-missions-candidate-detail',
    templateUrl: 'missions-candidate-detail.html'
})
export class MissionsCandidateDetailPage {
    mission: any;
    segment: any;
    alreadyRegistered: any;
    hide_popover:boolean = false;

    constructor(
        public missionsData: MissionsData,
        public navParams: NavParams,
        public modalCtrl: ModalController,
        public userData: UserData,
        public uiData: UiData,
        public navCtrl: NavController,
        public alertCtrl: AlertController,
        public popoverCtrl : PopoverController
    ) {

    }

    ionViewDidLoad() {
        this.segment = "job";
        this.alreadyRegistered = false;
        /*this.missionsData.load().subscribe((data: any) => {
            for(let i=0;i<data.length;i++){
                if(data[i].id === this.navParams.data.missionId)
                {
                    this.mission = data[i];
                    break;
                }
            }
            this.getUserInfos();
        });*/
        this.getUserInfos();
    }
    getUserInfos() {
        var that = this;
        that.userData.userSession().subscribe(session => {
            if(session!==null)
            {
                that.userData.load().subscribe(user => {
                    var missionsCandidates = that.userData.get('missionCandidates');
                    if(missionsCandidates[that.navParams.data.missionId])
                    {
                        that.mission = missionsCandidates[that.navParams.data.missionId].mission;
                    }
                    if(that.mission) {
                        that.alreadyRegistered = that.userData.get('missionCandidates/' + that.mission.id);
                    }
                });
            }
        });
    }
    cancelMission(mission)
    {
        var that = this;
        let alert = this.alertCtrl.create({
            title: 'Annulation d\'une candidature',
            message: 'Vous souhaitez annuler votre candidature pour ce poste de '+mission.job+'.<br/><br/> Etes vous sûr ? ',
            buttons: [
                {
                    text: 'Non',
                    handler: () => {

                    }
                },
                {
                    text: 'Oui',
                    handler: () => {
                        this.userData.set('missionCandidates/' + that.mission.id + '/status','canceled');
                        this.navCtrl.popTo(MissionsCandidatePage);
                    }
                }
            ]
        });
        // now present the alert on top of all other content
        alert.present();
    }

    /*goSupport()
    {
        this.navCtrl.push(SupportPage, { missionId: this.mission.id });
    }*/
    goSupport()
    {
        this.navCtrl.push(SupportPage, { missionId: this.mission.id, prefix: "A propos de ma candidature sur la mission \""+this.mission.name+"\" (ref."+this.mission.id+") : " });
    }
    goChat()
    {
        this.navCtrl.push(SupportPage, {
            missionId: this.mission.id,
            thread:'mission'+this.mission.id
        });
    }
    signMission(missionData: any) {
        // go to the session detail page
        // and pass in the session data
        this.navCtrl.push(MissionsSignPage, { missionId: missionData.id, name: missionData.name });
    }
    recordVideo(missionData: any) {
        let videoRecordModal = this.modalCtrl.create(VideoWizardForm, { mission: missionData });
        videoRecordModal.onDidDismiss(data => {
            if(data)
            {

            }
            else
            {

            }
        });
        videoRecordModal.present();
    }
    seeMap()
    {
        let modal = this.modalCtrl.create(LocationViewer, {mission: this.mission,searchFilters:this.userData.get('searchFilters')});
        modal.present();

        modal.onWillDismiss((data: any[]) => {
        });
    }
    presentPopover(event: Event) {
        let popover = this.popoverCtrl.create(MissionCandidateDetailPopover,
            {
                video: this.alreadyRegistered && this.alreadyRegistered.status=='submitted' && !this.alreadyRegistered.video,
                cancel: this.alreadyRegistered.status=='submitted',
                support: true,
                locate: true,
                chat: this.alreadyRegistered.status=='accepted' && this.alreadyRegistered.origin=='suggested',
            });
        var that = this;
        popover.onDidDismiss(data => {
            if(data == 'cancel')
            {
                that.cancelMission(that.mission)
            }
            if(data == 'support')
            {
                that. goSupport();
            }
            if(data == 'video')
            {
                that.recordVideo(that.mission);
            }
            if(data == 'locate')
            {
                that.seeMap();
            }
            if(data == 'chat')
            {
                that.goChat();
            }
        });
        popover.present({ ev: event });
    }
}



// WEBPACK FOOTER //
// ./src/pages/missions/missions-candidate/missions-candidate-detail/missions-candidate-detail.ts